import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ClientProfileService, UserService} from "../../_services";
import {WorkstreamService} from "../../_services/workstream.service";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";
import {LoginHelper} from "../../helpers";

@Component({
    standalone: false,
  selector: "recommended-solutions-list",
  templateUrl: 'recommended-solutions-list.component.html',
  styleUrls: ['./recommended-solutions-list.component.scss'],
})

export class RecommendedSolutionsListComponent implements OnInit {
  users: any;
  list: any;
  logoUrl?: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public service: RecommendedSolutionService,
              public dialogRef: MatDialogRef<RecommendedSolutionsListComponent>)
  {
    this.list = data.entity;
    this.setLogoUrl();
  }
  ngOnInit(): void {
  }

  save(): void {
    this.service.saveList(this.list).subscribe(r => this.close());
  }

  close(): void {
    this.dialogRef.close();
  }

  setLogoUrl(){
    this.logoUrl = '/api/attachments/file?name=' + encodeURIComponent(this.list.logoFileName) + '&path=Account/RecommendedSolutions/' + '&token=' + LoginHelper.getFileToken()
  }

  public addLogo(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {

      this.service.uploadLogo(attachments[0])
        .subscribe(data => {
          this.list.logoFileName = data.name;
          this.setLogoUrl();
        });
    }
  }
}
